import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/apiClient'
import { type OrganizationDetails } from '@/features/auth/auth-model'
import { USER_SESSION_QUERY_KEY } from '@/shared/hooks/api/auth'

/** Payload for PATCH /v1/organizations/:id (partial). */
export type OrganizationUpdateRequest = Record<string, string | undefined>

export const useDoesOrganizationRequiresLocalAddress = (
  placeOfRegistration: string | undefined | null
) => {
  const code = placeOfRegistration?.trim().toLowerCase()
  return code === 'cn'
}

export const useSaveOrganizationMandatoryInfo = (organizationId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: OrganizationDetails) => {
      const response = await apiClient.post<{
        id: string
      }>(`/v1/organizations/${organizationId}/info`, payload)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    },
  })
}

export const useUpdateOrganization = (organizationId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: OrganizationUpdateRequest) => {
      const response = await apiClient.patch(
        `/v1/organizations/${organizationId}`,
        payload
      )
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_SESSION_QUERY_KEY] })
    },
  })
}
